import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { select, takeLatest } from 'redux-saga/effects';
import { POP_STATE } from '../actions/historyActions';
import { getHideBackButton } from '../selectors/historySelector';

function* handlePopState() {
  const isHideBackButton = yield select(getHideBackButton);
  if (isHideBackButton) {
    EmmaFactory.createInstance().then((e) => e.instance.resetNavigation());
  }
}

function* historySaga() {
  yield takeLatest(POP_STATE, handlePopState);
}

export default historySaga;
